module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-1-e107e3c3496f7373af67639c82fc4e6c.jpg";